import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../..";
import { officeApi } from "../../../api/config";
import { GetLeader } from "../../../api/userapi";
import { UserCardState } from "../../../interface/interface";
import { LoadingChange } from "../../../reducers/config";
import {
  InvitationLaeder,
  LeaderChange,
  LeaderInter,
} from "../../../reducers/data";

type Props = {
  __cancel: () => void;
  content: string;
  dispatch: AppDispatch;
};

function TeamLeaderPopup({ __cancel, content, dispatch }: Props) {
  const [data, setData] = useState<UserCardState[]>([]);
  const [displayData, setDisplayData] = useState<UserCardState[]>([]);
  const handsearch = useCallback(
    (e: string) => {
      console.log(e);
      console.log(data);
      if (e.length > 0) {
        setDisplayData(
          data.filter(
            (item) =>
              (item.login_nm && item.login_nm.includes(e)) ||
              item.login_id.includes(e) ||
              item.usr_email.includes(e)
          )
        );
      } else {
        setDisplayData(data);
      }
    },
    [data]
  );

  const updateLaeder = useCallback(
    (data: LeaderInter) => {
      if (content === "invitation") {
        dispatch(InvitationLaeder(data));
      } else {
        dispatch(LeaderChange(data));
      }

      __cancel();
    },
    [dispatch, __cancel]
  );
  useEffect(() => {
    dispatch(LoadingChange(true));
    GetLeader().then(({ data }) => {
      if (data) {
        setData(data);
        setDisplayData(data);
      }
      dispatch(LoadingChange(false));
    });
    return () => {};
  }, [dispatch]);

  return (
    <div className="teamleader-popup">
      <div className="title">팀플리더를 선택해주세요</div>
      <form
        className="input-box"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className="left">
          <input
            type="text"
            placeholder="회원명 검색"
            className="input"
            onChange={(e) => {
              handsearch(e.target.value);
            }}
          ></input>
          <img className="search" src="/assets/common/search.svg"></img>{" "}
        </div>
      </form>

      {data.length > 0 ? (
        <>
          <div className="name-box">
            <div className="title1">이름</div>
            <div className="title2">아이디</div>
            <div className="title3">이메일</div>
          </div>
          <div className="list">
            {displayData.map(
              ({ login_nm, login_id, usr_email, usr_id }, index) => {
                return (
                  <div
                    key={index}
                    className="box"
                    onClick={() => {
                      updateLaeder({
                        id: usr_id,
                        name: login_nm,
                        email: usr_email,
                      });
                    }}
                  >
                    {/* usr_nm을 login_nm으로 바꿈 */}
                    <div className="name">{login_nm}</div>
                    <div className="id">{login_id}</div>
                    <div className="email">{usr_email}</div>
                  </div>
                );
              }
            )}
          </div>
        </>
      ) : (
        <div className="not-list">
          <div className="img">
            <img src="/assets/common/popup-delete.svg"></img>
          </div>
          <div className="title">해당 회원은 존재하지 않습니다.</div>
        </div>
      )}
    </div>
  );
}

export default TeamLeaderPopup;
